var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("TableModalForm", {
    ref: "table",
    attrs: {
      headers: _vm.headers,
      items: _vm.completedTasks,
      dense: "",
      loading: _vm.isLoading,
      showNew: false,
      name: "Completed Tasks",
      slots: [{ name: "actions" }, { name: "order" }, { name: "created" }],
      "sort-by": "created",
      "sort-desc": true,
    },
    on: {
      creating: _vm.creating,
      refresh: _vm.refresh,
      "item-selected": _vm.itemSelected,
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function () {
          return [
            _c("FormCompletedTask", {
              attrs: { Task: _vm.editCompletedTask, isSaving: _vm.isSaving },
              on: {
                save: _vm.save,
                cancel: function ($event) {
                  _vm.$refs.table.dialog = false
                },
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "created",
        fn: function ({ item }) {
          return [_vm._v(" " + _vm._s(_vm.formatDateTime(item.created)) + " ")]
        },
      },
      {
        key: "actions",
        fn: function ({ item }) {
          return [
            _c(
              "v-btn-toggle",
              [
                _c(
                  "v-btn",
                  {
                    attrs: { color: "default", small: "" },
                    on: {
                      click: function ($event) {
                        return _vm.edit(item)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("common.buttons.edit")) + " ")]
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }